import { queryOptions } from "@tanstack/react-query";
import type { ApiKeyResponse } from "@/app/api-keys/type";
import { getCoordinatorApi } from "@/lib/api";
import { apiKeysKeys } from "./query-keys";

const fetchApiKeys = async ({
  projectId,
  organizationId,
}: {
  projectId: string;
  organizationId: string;
}): Promise<ApiKeyResponse> => {
  const api = getCoordinatorApi({ organizationId, projectId });
  const { data } = await api.get<ApiKeyResponse>("/api_keys");
  return data;
};

export const apiKeysQueryOptions = ({
  projectId,
  organizationId,
}: {
  projectId: string;
  organizationId: string;
}) =>
  queryOptions<ApiKeyResponse>({
    queryKey: apiKeysKeys.list({
      scope: { organizationId, projectId },
    }),
    queryFn: () => fetchApiKeys({ projectId, organizationId }),
  });
